import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function LeftChevronIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 8 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.55518 16L0.228993 8.61875C-0.0763309 8.26301 -0.0763309 7.737 0.228993 7.38125L6.55518 0L8 1.23845L2.20361 8.00048L7.99905 14.7615L6.55518 16Z" />
      </svg>
    </Icon>
  );
}
